import { render, staticRenderFns } from "./FirstAccessPassword.vue?vue&type=template&id=3ecb580e&scoped=true"
import script from "./FirstAccessPassword.vue?vue&type=script&lang=ts"
export * from "./FirstAccessPassword.vue?vue&type=script&lang=ts"
import style0 from "./FirstAccessPassword.vue?vue&type=style&index=0&id=3ecb580e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ecb580e",
  null
  
)

export default component.exports